export default {
    setFastLink(event) {
        let isA = event.target.nodeName === 'A',
            radio = isA ? event.target.previousElementSibling : event.target,
            srcContainer = event.target.parentNode.parentNode.lastElementChild,
            closest = event.target.closest('.filter__item')?.previousElementSibling?.textContent.trim(),
            val = isA ? event.target.textContent.trim() : event.target.nextElementSibling.textContent.trim(),
            eventParams = $filter.slide ? { [$filter.headers[$filter.slide - 1]]: { [closest]: val } } : { [closest]: val }

        $app.runEvent('filter', eventParams)

        radio.checked = true

        srcContainer.querySelectorAll('input,select').forEach((input, i) => {
            input.value = i ? radio.dataset.to : radio.dataset.from
        })

        event.target.closest('form').dispatchEvent(new Event('change'))
    },

    resetFastLink(event) {
        event.target.closest('.filter__item').querySelectorAll('.radio input').forEach(i => i.checked = false)
    },

    setNomatter(radio) {
        radio.checked = true

        radio.parentNode.parentNode.querySelectorAll(`input[type="checkbox"]`).forEach(input => {
            input.checked = false

            input.addEventListener('change', () => radio.checked = false)
        })
    },

    processLimited(container) {
        container.querySelectorAll('.filter__item--limited').forEach(item => {
            let height = 0

            for (let i = 0; i < item.dataset.limit; i++) {
                height += $(item.children[i]).outerHeight(true)
            }

            if (item.offsetHeight > height) {
                item.style.maxHeight = height + 'px'
            }

            if (item.previousElementSibling) {
                item.previousElementSibling.addEventListener('input', event => {
                    for (let i = 0; i < item.children.length; i++) {
                        let textLink = item.children[i].querySelector('.checkbox__label,a').textContent.toLowerCase().trim()

                        item.children[i].classList.toggle('d-none', textLink.indexOf(event.target.value.toLowerCase().trim()) < 0)
                    }
                })
            }
        })
    },

    setHookahNoSmoking(event) {
        document.getElementById('hookah-no-smoking').disabled = event.target.checked

        $filter.$el.querySelector(`[name="${event.target.name}"][value="${event.target.value}"]:not([id="${event.target.id}"])`).disabled = ! event.target.checked
    },

    setNyNight(event) {
        let withUnknown = event.target.parentNode.nextElementSibling

        withUnknown.classList.toggle('d-none', ! event.target.checked)
        withUnknown.firstElementChild.disabled = ! event.target.checked
    },

    showMetro(container, event) {
        $app.runEvent('click', event)

        container.classList.remove('d-none')

        $.fancybox.open(container, {
            afterShow: fancy => {
                this.processLimited(fancy.current.$content[0])

                fancy.current.$content.width(fancy.current.$content.width())
                fancy.current.$content.height(fancy.current.$content.height())
            },
            afterClose() {
                container.classList.add('d-none')
            }
        })

        return false
    }
}